import { render, staticRenderFns } from "./carSaleTotal.vue?vue&type=template&id=ddcef8aa&scoped=true"
import script from "./carSaleTotal.vue?vue&type=script&lang=js"
export * from "./carSaleTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcef8aa",
  null
  
)

export default component.exports